import { application, loadStimulusDefinitionsFromContexts } from "../../lib/stimulus";
import { AutosizeController } from "stimulus-library";

loadStimulusDefinitionsFromContexts(application, require.context(".", true, /_controller\.js$/));

application.register('autosize', AutosizeController);
